export interface FormSectionConfig {
  id: string;
  label: string;
  visible: boolean;
}

export const formSections: FormSectionConfig[] = [
  { id: "insured", label: "Insured & Contact", visible: true },
  { id: "certificate", label: "Certificate Details", visible: true },
  { id: "units", label: "Residential Unit Schedule", visible: true },
  { id: "description", label: "Property Description", visible: true },
  { id: "images", label: "Images", visible: true },
  { id: "financial", label: "Financial Config", visible: true },
  { id: "areas", label: "Areas", visible: true },
  { id: "facilities-recreational", label: "Recreational Facilities", visible: true },
  { id: "facilities-special", label: "Special Features", visible: true },
  { id: "damage", label: "Damage Provision", visible: true },
  { id: "photos", label: "Photos", visible: true },
  { id: "attachments", label: "Attachments", visible: true },
  { id: "summary", label: "Summary", visible: true },
  { id: "fsl", label: "Fire and Emergency Levy Statement", visible: true },
  { id: "notes", label: "Notes", visible: true },
  { id: "signature", label: "Signature", visible: true },
  { id: "housekeeping", label: "Housekeeping", visible: true },
  { id: "superseding", label: "Superseding", visible: true },
];
